module.exports = __webpack_public_path__ + "adaguc-logo-favicon-32x32.png";